import React from 'react';

import Container from '@mui/material/Container';
import makeStyles from '@mui/styles/makeStyles';
import { Footer } from '../../layout/Footer/Footer';

const useStyles = makeStyles(() => ({
  rootcontainer: {
    flexGrow: 1,
    height: '100%',
  },
}));

export function NotFoundPage() {
  const classes = useStyles();

  return (
    <>
      <Container
        component="main"
        maxWidth="xl"
        className={classes.rootcontainer}
      >
        Page Not Found
      </Container>
      <Footer />
    </>
  );
}
